// Labels for notes written during a Live session.
export const NOTE_TYPES = [
  { id: 'thought', icon: '💭', label: 'Thought' },
  { id: 'watching', icon: '👀', label: 'Watching' },
  { id: 'entered', icon: '✅', label: 'Entered' },
  { id: 'exited', icon: '🚪', label: 'Exited' },
  { id: 'skipped', icon: '⏭️', label: 'Skipped' },
  { id: 'feeling', icon: '😬', label: 'Feeling' },
];

export function noteType(id) {
  return NOTE_TYPES.find((t) => t.id === id) || NOTE_TYPES[0];
}
